module.exports = __webpack_public_path__ + "img/1.7b5b6f00.png";